// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".markdown_tofUa p{line-height:1.5rem;margin-bottom:1.5rem}.markdown_tofUa p:last-of-type{margin-bottom:0}@media (min-width:768px){.markdown_tofUa p{margin-bottom:2rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdown": "markdown_tofUa"
};
module.exports = ___CSS_LOADER_EXPORT___;
